/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Race } from '../../models/race';

export interface RacesRaceGuidPost$Params {
  raceGuid: string;
      body: Race
}

export function racesRaceGuidPost(http: HttpClient, rootUrl: string, params: RacesRaceGuidPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Race>> {
  const rb = new RequestBuilder(rootUrl, racesRaceGuidPost.PATH, 'post');
  if (params) {
    rb.path('raceGuid', params.raceGuid, {"style":"simple"});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Race>;
    })
  );
}

racesRaceGuidPost.PATH = '/races/{raceGuid}';
